// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-list-wrapper .common-list[data-v-b65293bc]{padding-top:16px;height:calc(100vh - 240px);min-height:360px;overflow-y:auto}.common-list-wrapper .page-component[data-v-b65293bc]{margin-top:10px}", ""]);
// Exports
module.exports = exports;
